module.exports = __webpack_public_path__ + "static/media/Titania.79d2c50d.png";